import { useContext, useState } from "react";
import StuntDriversContext from "./StuntDriversContext.jsx";
import { useEffect } from "react";
import Button from "../Button/Button.jsx";
import Icon from "../Icon/Icon.jsx";

const propTypes = {};

const StuntDriversInfo = (props) => {
  const [navigationLinks, setNavigationLinks] = useState(false);
  const [subtitle, setSubtitle] = useState(false);
  const [content, setContent] = useState(false);
  const [nextSectionTitle, setNextSectionTitle] = useState(false);

  // get data from context
  const {
    activeCategoryId,
    activeSectionId,
    currentCategory,
    currentSection,
    getCategoriesWithSections,
    handleSelect,
    mergedCategories,
  } = useContext(StuntDriversContext);

  useEffect(() => {
    const getCatFirstEnabledSection = (category) => {
      if (!category.sections) return;
      const firstSection = category.sections.find(
        (section) => section.isEnabled,
      );

      return category.sections.indexOf(firstSection);
    };

    const getCatLastEnabledSection = (category) => {
      if (!category.sections) return;

      const lastSection = [...category.sections]
        .reverse()
        .find((section) => section.isEnabled);

      return category.sections.indexOf(lastSection);
    };

    const getNextEnabledSection = (sections, currentIndex) => {
      if (!sections) return;
      const sectionsSubset = sections.slice(currentIndex + 1);
      return (
        sectionsSubset &&
        sections.indexOf(sectionsSubset.find((sect) => sect.isEnabled))
      );
    };

    const getPrevEnabledSection = (sections, currentIndex) => {
      if (!sections) return;
      const sectionsSubset = sections.slice(0, currentIndex).reverse();
      return (
        sectionsSubset &&
        sections.indexOf(sectionsSubset.find((sect) => sect.isEnabled))
      );
    };

    setSubtitle(currentCategory && currentCategory.subtitle);

    let activeCategoriesList = mergedCategories.map((cat) => cat.id);
    let categoriesCount = activeCategoriesList.length;
    let catIndex = activeCategoriesList.indexOf(activeCategoryId);
    let nextCatIndex = catIndex !== categoriesCount - 1 ? catIndex + 1 : 0;
    let prevCatIndex = catIndex !== 0 ? catIndex - 1 : categoriesCount - 1;

    if (!currentSection) {
      setContent(currentCategory && currentCategory.content);

      setNavigationLinks({
        next: [activeCategoriesList[nextCatIndex]],
        previous: [activeCategoriesList[prevCatIndex]],
      });

      setNextSectionTitle(mergedCategories[nextCatIndex].title);
    } else {
      setContent(currentSection.content);

      const activeCategories = getCategoriesWithSections();

      activeCategoriesList = activeCategories.map((cat) => cat.id);
      categoriesCount = activeCategories.length;
      catIndex = activeCategoriesList.indexOf(activeCategoryId);

      const sectionIndex = currentCategory.sections.indexOf(currentSection);
      const isLastSection =
        sectionIndex === getCatLastEnabledSection(currentCategory);
      const isFirstSection =
        sectionIndex === getCatFirstEnabledSection(currentCategory);

      nextCatIndex = isLastSection
        ? catIndex === categoriesCount - 1
          ? 0
          : catIndex + 1
        : catIndex;
      prevCatIndex = isFirstSection
        ? catIndex !== 0
          ? catIndex - 1
          : categoriesCount - 1
        : catIndex;

      const nextSectionIndex = isLastSection
        ? getCatFirstEnabledSection(activeCategories[nextCatIndex])
        : getNextEnabledSection(currentCategory.sections, sectionIndex);
      const previousSectionIndex = isFirstSection
        ? getCatLastEnabledSection(activeCategories[prevCatIndex])
        : getPrevEnabledSection(currentCategory.sections, sectionIndex);

      setNavigationLinks({
        next: [activeCategoriesList[nextCatIndex], nextSectionIndex + 1],
        previous: [
          activeCategoriesList[prevCatIndex],
          previousSectionIndex + 1,
        ],
      });

      setNextSectionTitle(
        isLastSection && activeCategories[nextCatIndex].title,
      );
    }
  }, [
    currentSection,
    currentCategory,
    getCategoriesWithSections,
    mergedCategories,
    activeCategoryId,
    activeSectionId,
  ]);

  return (
    <>
      {currentCategory && (activeCategoryId || activeSectionId) ? (
        <div className="stunt-drivers__info">
          {subtitle && (
            <h3 className="stunt-drivers__info-subtitle h4">{subtitle}</h3>
          )}
          <div
            className="stunt-drivers__info-content rich-text"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
          <div className="stunt-drivers__info-navigation">
            <button
              className="stunt-drivers__info-button"
              onClick={() =>
                navigationLinks && handleSelect(...navigationLinks.previous)
              }
            >
              <Icon iconName="chevron-left" /> Previous
            </button>
            <button
              className="stunt-drivers__info-button"
              onClick={() =>
                navigationLinks && handleSelect(...navigationLinks.next)
              }
            >
              Next <Icon iconName="chevron-right" />
            </button>
            {nextSectionTitle && (
              <span className="stunt-drivers__info-next-section">
                {nextSectionTitle}
              </span>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

StuntDriversInfo.propTypes = propTypes;
export default StuntDriversInfo;
